import * as React from 'react';
import {Radio} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import './RadioGroupFormItem.css';
import {RadioChangeEvent, RadioProps} from "antd/lib/radio/interface";

interface RadioGroupFormItemProps extends BaseFormItemProps {
  options?: RadioProps[];
  onChange?: (e: RadioChangeEvent) => void;
}

class RadioGroupFormItem extends React.Component<RadioGroupFormItemProps, {}> {

  public render(): React.ReactNode {
    const {disabled, options, onChange, label, initialValue} = this.props;
    return <BaseFormItem
      {...this.props}
      initialValue={initialValue}
      label={label}
      className="two-rows-label"
      input={
        <Radio.Group
          className="mild-disabled"
          disabled={disabled}
          onChange={onChange}
        >
          {options && options.map(opt => {
            return (
              <Radio
                {...opt}
                key={String(opt.value)}
                value={opt.value}
              >
                {opt.name}
              </Radio>
            )
          })}
        </Radio.Group>
      }
    />
  }
}

export default RadioGroupFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/RadioGroupFormItem.tsx